import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/brand/logo-hexapla-light.svg'


const _hoisted_1 = { class: "lab" }
const _hoisted_2 = { class: "lab-bar" }
const _hoisted_3 = {
  key: 0,
  class: "sections"
}
const _hoisted_4 = {
  key: 1,
  class: "who"
}
const _hoisted_5 = { class: "lab-body" }
const _hoisted_6 = {
  key: 0,
  class: "lab-foot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_RelationVocabularyGate = _resolveComponent("RelationVocabularyGate")!
  const _component_HoverCard = _resolveComponent("HoverCard")!
  const _component_IndexPanel = _resolveComponent("IndexPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "brand"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "The Hexapla Institute"
          }, null, -1),
          _createElementVNode("span", { class: "lab-name" }, "Labs", -1)
        ]))]),
        _: 1
      }),
      (_ctx.signedIn)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              "exact-active-class": "is-active"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Browse", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/search",
              "active-class": "is-active"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Search", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/relations",
              "active-class": "is-active"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Relations", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.signedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.name), 1),
            _createElementVNode("button", {
              class: "sign-out",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.leave && _ctx.leave(...args)))
            }, "Sign out")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.signedIn)
        ? (_openBlock(), _createBlock(_component_RelationVocabularyGate, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
    ]),
    (_ctx.signedIn)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/credits" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Sources and credits", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_HoverCard),
    _createVNode(_component_IndexPanel)
  ]))
}